import React, { useEffect, useState } from "react";
import EmailVerify from "./Components/Dashbord/EmailVerify";
import PharmacyCardViews from "./Components/Dashbord/PharmacyCardViews";

const PharmacyDashboard = () => {
  const [userdata, setUserdata] = useState({});

  useEffect(() => {
    const userData = localStorage.getItem("userData");
    console.log("userData", userData);
    if (userData) {
      setUserdata(userData);
    }
  }, []);

  return (
    <>
      <div className="subbody" style={{ width: "100%", padding: "2% 4%" }}>
        {userdata.activation_key == null && <EmailVerify />}
        <PharmacyCardViews />
      </div>
    </>
  );
};

export default PharmacyDashboard;
